// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1pF0y","colCheckbox":"styles_colCheckbox__1Nr_b"};